
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.99 9.78999C20.5 9.38999 20.5 8.60999 19.99 8.20999L13.23 2.94999C12.51 2.38999 11.5 2.38999 10.77 2.94999L9.40998 4.01999L17.29 11.9L19.99 9.78999ZM19.99 13.28L19.98 13.27C19.62 12.99 19.12 12.99 18.76 13.27L18.71 13.31L20.11 14.71C20.48 14.3 20.45 13.64 19.99 13.28ZM21.44 18.88L4.11998 1.55999C3.72998 1.16999 3.09998 1.16999 2.70998 1.55999C2.31998 1.94999 2.31998 2.57999 2.70998 2.96999L6.22998 6.48999L4.00998 8.20999C3.49998 8.60999 3.49998 9.38999 4.00998 9.78999L10.77 15.05C11.49 15.61 12.5 15.61 13.23 15.05L14.1 14.37L15.52 15.79L12.6 18.06C12.24 18.34 11.73 18.34 11.37 18.06L5.21998 13.28C4.85998 13 4.35998 13 3.99998 13.28C3.48998 13.68 3.48998 14.45 3.99998 14.85L10.76 20.11C11.48 20.67 12.49 20.67 13.22 20.11L16.94 17.22L20.01 20.29C20.4 20.68 21.03 20.68 21.42 20.29C21.83 19.9 21.83 19.27 21.44 18.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-layers-clear`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLayersClear

    ```js
    <b-new-b-icon-layers-clear />
    ```
</docs>


